import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatThumbsupEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_THUMBS_UP),
    version: Literal(1),
  })
);

const AiChatThumbsupEventServerRuntype = AiChatThumbsupEventBrowserRuntype.And(
  CoreEventRuntype
).And(
  Record({
    sessionId: String,
  })
);

type AiChatThumbsupBrowserEvent = Static<typeof AiChatThumbsupEventBrowserRuntype>;
type AiChatThumbsupServerEvent = Static<typeof AiChatThumbsupEventServerRuntype>;

const isAiChatThumbsupBrowserEvent = (obj: BaseEvent): obj is AiChatThumbsupBrowserEvent => {
  return obj.event === 'AI Assist Thumbs Up';
};

const isAiChatThumbsupServerEvent = (obj: BaseEvent): obj is AiChatThumbsupServerEvent => {
  return obj.event === 'AI Assist Thumbs Up';
};

export {
  isAiChatThumbsupBrowserEvent,
  isAiChatThumbsupServerEvent,
  AiChatThumbsupEventBrowserRuntype,
  AiChatThumbsupEventServerRuntype,
  type AiChatThumbsupBrowserEvent,
  type AiChatThumbsupServerEvent,
};
